import { Box, Button, Group, Modal, Select, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useCallback } from "react";
import type { PanelWorkflowKind } from "../../../services/admin/panels.service";

export interface PanelFilters {
  status: "" | "active" | "inactive";
  workflowKind: "" | PanelWorkflowKind;
}

interface PanelFilterModalProps {
  opened: boolean;
  filters: PanelFilters;
  onClose: () => void;
  onApply: (filters: PanelFilters) => void;
}

export function PanelFilterModal({
  opened,
  filters,
  onClose,
  onApply,
}: PanelFilterModalProps) {
  const form = useForm<PanelFilters>({ initialValues: filters });
  const handleApply = useCallback(
    (values: PanelFilters) => onApply(values),
    [onApply]
  );
  const handleClear = useCallback(() => {
    form.setValues({ status: "", workflowKind: "" });
  }, [form]);

  return (
    <Modal.Root
      opened={opened}
      onClose={onClose}
      closeOnClickOutside={false}
      size="md"
      centered
    >
      <Modal.Overlay />
      <Modal.Content
        style={{ display: "flex", flexDirection: "column", maxHeight: "90vh" }}
      >
        <Modal.Header>
          <Modal.Title>Filter panels</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body style={{ overflowY: "auto" }}>
          <Box
            component="form"
            id="panel-filter-form"
            onSubmit={form.onSubmit(handleApply)}
          >
            <Stack gap="md">
              <Select
                label="Status"
                placeholder="All statuses"
                data={[
                  { value: "active", label: "Active" },
                  { value: "inactive", label: "Inactive" },
                ]}
                clearable
                {...form.getInputProps("status")}
              />
              <Select
                label="Workflow"
                placeholder="All workflows"
                data={[
                  { value: "ordinary", label: "Ordinary panel" },
                  { value: "tissue_cypher", label: "Tissue Cypher" },
                ]}
                clearable
                {...form.getInputProps("workflowKind")}
              />
            </Stack>
          </Box>
        </Modal.Body>
        <Group
          justify="space-between"
          p="md"
          style={{ borderTop: "1px solid var(--mantine-color-default-border)" }}
        >
          <Button variant="subtle" onClick={handleClear}>
            Clear filters
          </Button>
          <Group gap="sm">
            <Button variant="default" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" form="panel-filter-form">
              Apply filters
            </Button>
          </Group>
        </Group>
      </Modal.Content>
    </Modal.Root>
  );
}
